/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// EMBED : ADD ANSWER : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	addanswer: {
		fontSize: pxToEm(12),
		width: 'auto',
		position: 'relative',
		bottom: pxToEm(5),
		zIndex: '2'
	}
});